import { useQuery } from '@tanstack/react-query';

import backendService from '../services/backendService';

export const useLatestGenerators = () => {
  const { data: generators, isFetching: isFetchingGenerators } = useQuery(
    ['generators-latest'],
    async () => {
      const generators = await backendService.instance.generators.latest();
      return generators;
    },
    {
      staleTime: 1000 * 60 * 5,
    },
  );

  return {
    generators,
    isFetchingGenerators,
  };
};
